<template>
  <div>
    <section id="bar-top">
      <div class="container infoContainer">
        <div class="w-full content">
          <ul
            class="lista-top justify-center list-none flex flex-row w-full items-center faqs"
          >
            <li class="mr-6">
              <router-link class="flex flex-row items-center" to="/atendimento">
                <i
                  class="fa fa-phone icon-bar-top p-4 mr-2"
                  aria-hidden="true"
                ></i>
                <span class="text-lg text-lg">Fale conosco</span>
              </router-link>
            </li>
            <li class="mr-6">
              <a
                v-if="$store.getters.siteConfig?.app_store_faq_url"
                :href="$store.getters.siteConfig?.app_store_faq_url"
                class="flex flex-row items-center"
              >
                <i
                  class="fa fa-question icon-bar-top p-4 mr-2"
                  aria-hidden="true"
                ></i>
                <span class="text-lg">Dúvidas frequentes</span>
              </a>
              <router-link
                v-else
                class="flex flex-row items-center"
                to="/atendimento"
              >
                <i
                  class="fa fa-question icon-bar-top p-4 mr-2"
                  aria-hidden="true"
                ></i>
                <span class="text-lg">Dúvidas frequentes</span>
              </router-link>
            </li>
            <li class="mr-6">
              <router-link
                v-if="isAuthenticated"
                class="flex flex-row items-center"
                tag="a"
                to="/minha-conta/pedidos"
              >
                <i
                  class="fa fa-archive icon-bar-top p-4 mr-2"
                  aria-hidden="true"
                ></i>
                <span class="text-lg">Meus pedidos</span>
              </router-link>
              <a v-else class="flex flex-row items-center" :href="logginUrl">
                <i
                  class="fa fa-archive icon-bar-top p-4 mr-2"
                  aria-hidden="true"
                ></i>
                <span class="text-lg">Meus pedidos</span>
              </a>
            </li>
          </ul>
          <div class="userInfos" @click="showModalRazao = true">
            <RazaoCardInfo
              v-if="isAuthenticated"
              ref="RazaoCardInfo"
              @listagemRedes="handleListagemRedes"
              @loadingRedes="handleLoadingRedes"
            />
          </div>
        </div>
      </div>
    </section>
    <modal-razao
      v-if="
        isAuthenticated &&
        (showModalRazao || !selectUnidade) &&
        (!clientesCarregados || hasClientesDisponiveis)
      "
      :listagem-redes="listagemRedes"
      :select-unidade="selectUnidade"
      :is-loading="isLoadingRedes"
      @selectUnidade="handleSelectUnidade"
      @close="showModalRazao = false"
    />
    <modal-razao-fallback
      v-if="isAuthenticated && clientesCarregados && !hasClientesDisponiveis"
    />
  </div>
</template>

<script>
import * as global from "@/app/global";
import RazaoCardInfo from "@/components/razao-card-info/RazaoCardInfo.vue";
import ModalRazao from "@/components/root/modal/ModalRazao.vue";
import ModalRazaoFallback from "@/components/root/modal/ModalRazaoFallback.vue";

export default {
  name: "BarTop",
  components: {
    RazaoCardInfo,
    ModalRazao,
    ModalRazaoFallback,
  },
  data() {
    return {
      showModalRazao: false,
      infoUsuario: {},
      listagemRedes: [],
      clientesCarregados: false,
      isLoadingRedes: false,
    };
  },
  computed: {
    logginUrl() {
      return `${process.env.VUE_APP_CLIENTE}?rd=minha-conta/pedidos`;
    },
    isAuthenticated() {
      return this.$store.getters.getIsAuthenticated;
    },
    getTelTelevenda() {
      return global.mascaraTelefone(
        this.$store.getters.informacaoGlobal.tel_televenda
      );
    },
    getTelSac() {
      return global.mascaraTelefone(
        this.$store.getters.informacaoGlobal.tel_sac
      );
    },
    selectUnidade() {
      return Number(this.$store.getters.clienteAtual);
    },
    hasClientesDisponiveis() {
      return this.listagemRedes.length > 0;
    },
  },
  methods: {
    handleListagemRedes(listagemRedes) {
      console.log("listagem redes", listagemRedes);
      this.listagemRedes = listagemRedes;
      this.clientesCarregados = true;
      if (!listagemRedes.length) {
        this.showModalRazao = false;
      }
    },
    handleLoadingRedes(isLoading) {
      this.isLoadingRedes = isLoading;
    },
    openRazaoModal() {
      if (this.clientesCarregados && !this.hasClientesDisponiveis) return;
      this.showModalRazao = true;
    },
    handleSelectUnidade(redeId) {
      this.$refs.RazaoCardInfo.selectUnidade = redeId;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/css/sass/bootstrap/variables";
@import "~@/assets/css/global.css";

#bar-top {
  background-color: var(--brand-primary, $brand-primary);
  min-height: 35px;
  line-height: 35px;
  color: var(--brand-primary-contrast, "#fff");
  -webkit-transition: all 0.2s ease;
  -moz-transition: all 0.2s ease;
  -ms-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  transition: all 0.2s ease;
  padding: 0 25px;
  z-index: 1;
  position: relative;

  a {
    color: var(--brand-primary-contrast, "#fff");
  }

  .infoContainer {
    max-width: initial;
    padding: 0;
    .content {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      padding-top: 10px;
      height: 45px;
      .userInfos {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        color: var(--brand-primary-contrast, "#fff");
        gap: 20px;
        grid-column: 3;
        font-size: 11.75px;
        min-width: 0;
        max-width: 100%;
      }
      ul.faqs {
        grid-row: 1;
        grid-column: 2;
      }
    }
  }
}
.icon-bar-top {
  font-size: 10px;
  background-color: var(--brand-accent, $brand-accent);
  color: var(--brand-primary, $brand-primary);
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}
.scroll-hidden {
  // margin-top: -35px;
  // margin-top: -85px;
  margin-top: -34px;
}
ul,
ol {
  margin-top: 0;
  margin-bottom: 0;
}

@media (min-width: 992px) and (max-width: 1550px) {
  #bar-top {
    padding: 0 15px;
    .infoContainer {
      .content {
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-between;
        align-items: center;
        gap: 16px;

        .faqs {
          width: initial;
          padding-left: 0;
          flex-wrap: nowrap;
          flex-shrink: 1;
          min-width: 0;

          li {
            flex-shrink: 0;

            a,
            .flex {
              white-space: nowrap;
            }
          }

          .icon-bar-top {
            flex-shrink: 0;
          }
        }
      }
    }
  }
}

@media (max-width: 991px) {
  #bar-top {
    display: none;
  }
}
</style>
